// public/brand/favicon-dark.png는 흰 선+투명 배경이라 다크 UI(지금 앱 전체)에서 쓴다 — 라이트 배경에
// 놓을 일이 생기면 public/brand/favicon-light.png(검정 선)로 바꿀 것.
export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-2 font-semibold tracking-tight ${className ?? ""}`}
    >
      {/* 작은 정적 로고라 별도 이미지 최적화가 필요 없다 */}
      <img
        src="/brand/favicon-dark.png"
        alt=""
        aria-hidden
        className="size-8"
      />
      Dabar Note
    </span>
  );
}
